import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react';
import { close } from 'ionicons/icons';
import React from 'react';
import { css } from '@emotion/react';
import { Title } from '../Title';

interface ModalHeaderProps {
  onClose: () => void;
  title: string;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ onClose, title }) => {
  const modalHeaderCss = {
    header: css({
      backgroundColor: 'var(--ion-color-secondary)',
    }),
    toolbar: css({
      '--background': 'var(--ion-background-color)',
    }),
  };

  return (
    <IonHeader css={modalHeaderCss.header} mode="ios">
      <IonToolbar css={modalHeaderCss.toolbar}>
        <IonTitle>
          <Title level={1} fontSize="1rem">
            {title}
          </Title>
        </IonTitle>
        <IonButtons slot="end">
          <IonButton size="small" onClick={onClose} color="dark">
            <IonIcon icon={close} slot="icon-only" />
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default ModalHeader;
